import { Button, Form, Col } from "react-bootstrap";

function ReferralFilter({
  mobile,
  setMobile,
  inviteCode,
  setInviteCode,
  createdFrom,
  setCreatedFrom,
  createdTo,
  setCreatedTo,
  usedFrom,
  setUsedFrom,
  usedTo,
  setUsedTo,
  handleSearch,
}) {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >
      <style>{`
        .referral-date-input-empty:not(:focus)::-webkit-datetime-edit {
          color: transparent;
        }
      `}</style>
      <Form.Row className="align-items-end">
        <Form.Group as={Col} sm="2">
          <Form.Label>Утасны дугаар</Form.Label>
          <Form.Control
            type="text"
            maxLength={8}
            value={mobile}
            onChange={(e) =>
              setMobile(e.target.value.replace(/\D/g, "").slice(0, 8))
            }
          />
        </Form.Group>
        <Form.Group as={Col} sm="2">
          <Form.Label>Промо код</Form.Label>
          <Form.Control
            type="text"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
          />
        </Form.Group>
        <Form.Group as={Col} sm="2">
          <Form.Label>Үүссэн огноо (эхлэх)</Form.Label>
          <Form.Control
            type="date"
            className={createdFrom ? "" : "referral-date-input-empty"}
            value={createdFrom}
            onChange={(e) => setCreatedFrom(e.target.value)}
          />
        </Form.Group>
        <Form.Group as={Col} sm="2">
          <Form.Label>Үүссэн огноо (дуусах)</Form.Label>
          <Form.Control
            type="date"
            className={createdTo ? "" : "referral-date-input-empty"}
            value={createdTo}
            onChange={(e) => setCreatedTo(e.target.value)}
          />
        </Form.Group>
        <Form.Group as={Col} sm="2">
          <Form.Label>Ашигласан огноо (эхлэх)</Form.Label>
          <Form.Control
            type="date"
            className={usedFrom ? "" : "referral-date-input-empty"}
            value={usedFrom}
            onChange={(e) => setUsedFrom(e.target.value)}
          />
        </Form.Group>
        <Form.Group as={Col} sm="2">
          <Form.Label>Ашигласан огноо (дуусах)</Form.Label>
          <Form.Control
            type="date"
            className={usedTo ? "" : "referral-date-input-empty"}
            value={usedTo}
            onChange={(e) => setUsedTo(e.target.value)}
          />
        </Form.Group>
      </Form.Row>
      <Button
        variant="primary"
        className="btn btn-sm"
        size="md"
        onClick={handleSearch}
      >
        Хайх
      </Button>
    </Form>
  );
}

export default ReferralFilter;
